import React, { Component } from 'react'
import { connect } from 'react-redux'

import generalActions from 'redux/actions/generalActions'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import Modalizer from 'components/modalizer/modalizer'
import SchoolsSuggestionList from 'components/schools_suggestion_list/schools_suggestion_list'
import { privateLibrarySelectors } from 'redux/selectors'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import privateLibraryActions from 'redux/actions/privateLibraryActions'
import myAccountActions from 'redux/actions/myAccountActions'
import { localize } from 'helpers/translator'

class SwitchLibraryModal extends Component {

	constructor(props) {
		super(props)
		this.redirectToLibraryHandler = this.redirectToLibraryHandler.bind(this)
	}

	componentDidMount() {
		this.props.actions.searchSchoolsAction('', '0', '0', true) //empty search returns all schools available
	}

	redirectToLibraryHandler(value) {
		this.props.actions.closeModal(this.props.modalName)
		this.props.actions.redirectToLibrary(value.privateLibraryId)
	}

	render() {
		return (
			<Modalizer modalName={this.props.modalName} width='450px' closeAction={() => this.props.actions.closeModal(this.props.modalName)}>
				<SecondaryTitle
					text={localize('multiple_school_libraries_switch_modal_title')}
					isCentered={true}>
				</SecondaryTitle>
				<SchoolsSuggestionList
					options={this.props.schools}
					placeholder={localize('multiple_school_libraries_switch_modal_placeholder')}
					onClick={this.redirectToLibraryHandler}
					showBottomRow={false}
					autoFocus={true}
				/>
			</Modalizer>
		)
	}
}

function mapStateToProps(state) {
	return privateLibrarySelectors.privateLibrarySwitchModalSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		searchSchoolsAction: myAccountActions.searchSchools,
		redirectToLibrary: privateLibraryActions.redirectToLibrary,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SwitchLibraryModal)
